import { TopMenuBar as Bar } from "./top-menu-bar";
import { TopMenuRoot as Root } from "./top-menu-root";
import { TopMenuOverflowBar as OverflowBar } from "./top-menu-overflow-bar";
import { FloatingBarGroup as Group } from "../../floating-bar/floating-bar-group";
import { FloatingBarButton as Button } from "../../floating-bar/floating-bar-button";
import { FloatingBarDropdown as Dropdown } from "../../floating-bar/floating-bar-dropdown";
import { FloatingBarIcon as Icon } from "../../floating-bar/floating-bar-icon";

export const TopMenu = {
	Root,
	Bar,
	OverflowBar,
	Dropdown,
	Group,
	Icon,
	Button,
};
